import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Tiendas } from "../../Tiendas/Tiendas";
import { Areas } from "../Areas/Areas";
import { Regiones } from "../Regiones";
import { RegionesTiendasFilters } from "../RegionesTiendasFilters/RegionesTiendasFilters";
import { SubAreas } from "../SubAreas/SubAreas";
import { ACTEditarTienda } from "./ACTEditarTienda";

const columns = () =>
(
    {
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda Id' }),
        c_region_id: new EntityColumn<string>({ name: 'c_region_id', type: 'char', length: 20, flags: c.FK, prompt: 'Región Id' }),
        c_area_id: new EntityColumn<string>({ name: 'c_area_id', type: 'char', length: 20, flags: c.FK, prompt: 'Area Id' }),
        c_subarea_id: new EntityColumn<string>({ name: 'c_subarea_id', type: 'char', length: 20, flags: c.FK, prompt: 'Subarea Id' }),
        vc_domicilio_ruteo: new EntityColumn<string>({ name: 'vc_domicilio_ruteo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Domicilio Ruteo' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        regt_brwStandard: { name: 'regt_brwStandard', keyMappings: { c_tienda_id: 0 } },
        regt_brwTiendasPorRegion: {
            name: 'regt_brwTiendasPorRegion', keyMappings: { c_tienda_id: 0 }
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new RegionesTiendasFilters(client, parentKeys)
        },
    }
)

const lookups = () =>
(
    {
        'Regiones': {
            name: 'Regiones',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Regiones(client, parentKeys)
        },

        'Areas': {
            name: 'Areas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Areas(client, parentKeys)
        },

        'SubAreas': {
            name: 'SubAreas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new SubAreas(client, parentKeys)
        },

        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },

    }
)

const procs = () =>
(
    {
        regt_AgregarTienda: { name: 'regt_AgregarTienda' },
        regt_EliminarTienda: { name: 'regt_EliminarTienda' }
    }
)

const clientActions = () =>
(
    {
        ACTEditarTienda: ACTEditarTienda
    }
)

export class RegionesTiendasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('RegionesTiendas');
    }
}